export { getLayout } from './getLayout';
